import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonDownloadComponent } from './common-download.component';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { DirectiveModule } from 'src/app/shared/directive/directive.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    CommonDownloadComponent
  ],
  imports: [
    CommonModule,
    CustomFlexLayoutModule,
    FormsModule,
    MatInputModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    DirectiveModule,
    MatExpansionModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    CommonDownloadComponent
  ]
})
export class CommonDownloadModule { }
